import { getTodaysDate } from "@/lib/dayjs/get-todays-date";
import { CurrencyType } from "@/lib/gql/__generated__/graphql";

import type { MarketingCampaignFormModel } from "../type";

type Props = {
	hotelID: string;
	voucherID: string;
	queryData: MarketingCampaignFormModel["QueryData"];
};

export const DEFAULT_PRODUCT_CAMPAIGN_INPUT_MODEL = ({ hotelID, voucherID }: Props) => {
	const defaultPriceObject = {
		amount: 0,
		currencyType: CurrencyType.Jpy,
	};

	const todaysDate = getTodaysDate();

	const inputModel: MarketingCampaignFormModel["InputModel"] = {
		hotelID,
		voucherID,

		inSale: false,

		name: "",
		description: "",

		mainKeyVisual: {
			bucket: "",
			fileName: null,
			key: "",
			mimeType: null,
			region: "",
		},

		voucherPrice: defaultPriceObject,
		resourceAvailablePrice: defaultPriceObject,

		mailTemplate: "",
		voucherExplanationForHost: "",

		cinStart: todaysDate,
		cinEnd: todaysDate,

		voucherGiftList: [],
	} satisfies MarketingCampaignFormModel["InputModel"];

	return inputModel;
};
